"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TagsInput = require("./TagsInput.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TagsInput = function TagsInput(_ref) {
  var id = _ref.id,
      helper = _ref.helper,
      name = _ref.name,
      placeholder = _ref.placeholder,
      tagsList = _ref.value,
      onChange = _ref.onChange,
      label = _ref.label,
      error = _ref.error;
  var hasError = !!error;

  var inputTag = _react["default"].createRef();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      newTag = _useState2[0],
      onNewStateChange = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocus = _useState4[0],
      onFocusChange = _useState4[1];

  var handleInputChange = function handleInputChange(e) {
    onNewStateChange(e.target.value);
  };

  var deleteTag = function deleteTag(tag) {
    var tags = tagsList.filter(function (x) {
      return tag !== x;
    });
    onChange(tags);
  };

  var manageTags = function manageTags(e) {
    var keyCode = e.keyCode,
        value = e.target.value;

    if (keyCode === 13 && !tagsList.includes(value) && !!value.trim()) {
      var tags = [].concat(_toConsumableArray(tagsList), [value]);
      onNewStateChange('');
      onChange(tags);
    } else if (keyCode === 8 && !newTag && tagsList.length) {
      var _tags = _toConsumableArray(tagsList);

      _tags.pop();

      onChange(_tags);
    }
  };

  var focusInput = function focusInput() {
    inputTag.current.focus();
    onFocusChange(true);
  };

  return _react["default"].createElement(_TagsInput.StyleBase, null, !!label && _react["default"].createElement(_TagsInput.LabelStyle, {
    htmlFor: id,
    hasError: hasError
  }, label), !!helper && _react["default"].createElement(_TagsInput.HelperText, {
    hasError: hasError
  }, helper), _react["default"].createElement(_TagsInput.TagInputContainer, {
    onClick: focusInput,
    hasError: hasError,
    isFocus: isFocus
  }, tagsList.map(function (tag, i) {
    return _react["default"].createElement(_TagsInput.Tag, {
      key: i
    }, tag, _react["default"].createElement("span", {
      onClick: function onClick(e) {
        return deleteTag(tag, e);
      }
    }, _react["default"].createElement("svg", {
      width: "8",
      height: "8",
      xmlns: "http://www.w3.org/2000/svg"
    }, _react["default"].createElement("path", {
      d: "M5.485 4.071l2.122 2.121a1 1 0 1 1-1.415 1.415l-2.12-2.122L1.95 7.607A1 1 0 1 1 .536 6.192l2.12-2.12L.537 1.95A1 1 0 1 1 1.95.536l2.121 2.12L6.192.537A1 1 0 1 1 7.607 1.95L5.485 4.07z",
      fill: "#FFF",
      fillRule: "evenodd"
    }))));
  }), _react["default"].createElement(_TagsInput.InputStyle, {
    ref: inputTag,
    onKeyDown: manageTags,
    onBlur: function onBlur() {
      return onFocusChange(false);
    },
    onChange: handleInputChange,
    value: newTag,
    id: name,
    placeholder: placeholder,
    type: "text"
  })), hasError && _react["default"].createElement(_TagsInput.ErrorText, null, error));
};

TagsInput.propTypes = {
  id: _propTypes["default"].string.isRequired,
  helper: _propTypes["default"].string,
  error: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].array,
  onChange: _propTypes["default"].func
};
TagsInput.defaultProps = {
  name: 'tags',
  placeholder: 'Add a tag',
  value: [],
  onChange: function onChange() {}
};
var _default = TagsInput;
exports["default"] = _default;